<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-0 pb-5>
        <v-flex xs12 md8>
          <v-card
            style="
              background-color: transparent !important;
              border: 0px solid red !important;
            "
            flat
          >
            <v-card-title class="pt-6 pb-0 px-0 mb-3" v-if="!loadingList.about">
              <user-list-item
                :item="userData"
                :avatar="userData.Avatar"
                :avatarSize="'100'"
                :fullName="userData.FullName"
                :department="userData.Department"
                :company="userData.Company"
                :noBg="true"
                :divider="false"
                :buttonVisible="true"
                :buttonText="$t('buttons.sendMessage')"
                :buttonDisabled="false"
                :buttonTypeText="true"
                :width="'100%'"
                @sendMessage="(n) => this.sendMessage()()"
              />
            </v-card-title>

            <v-card-title v-if="userId" class="pt-1 pb-0 px-0 mb-2">
              <story-banner
                :userId="userId"
                :isProfileStories="true"
              ></story-banner>
            </v-card-title>
          </v-card>

          <v-tabs
            v-model="tab"
            background-color="transparent"
            grow
            color="defaultColor"
            style="border-bottom: 1px solid grey !important"
          >
            <v-tab
              v-for="tabItem in tabItems"
              :key="tabItem.data"
              @click="changeTab()"
            >
              {{ tabItem.title }}
            </v-tab>
          </v-tabs>

          <v-tabs-items
            v-model="tab"
            style="background-color: transparent !important"
          >
            <v-tab-item>
              <loading-progress :status="loadingList.about" />
              <div v-if="!loadingList.about">
                <v-list-item class="mt-7">
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 14px"
                      class="defaultColorLight--text font-weight-regular mb-3"
                      >{{ $t("labels.sicilNumber") }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Username }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="my-7" />
                <v-list-item class="mb-7">
                  <v-list-item-content>
                    <v-list-item-title
                      style="font-size: 14px"
                      class="defaultColorLight--text font-weight-regular mb-3"
                      >{{ $t("labels.area") }}</v-list-item-title
                    >
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Area }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      style="font-size: 16px"
                      class="defaultColor--text font-weight-bold"
                    >
                      {{ userData.Company }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-card class="greyCard" flat>
                  <v-list-item class="mb-7 pt-6 px-13">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.birthdate") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{
                          moment(userData.DateOfBirth)
                            .locale("tr")
                            .format("DD MMMM YYYY")
                        }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="my-3" />

                  <v-list-item class="mb-7 px-13">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.about") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{ userData.About }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider class="my-3" />

                  <v-list-item class="mb-7 px-13 pb-6">
                    <v-list-item-content>
                      <v-list-item-title
                        style="font-size: 14px"
                        class="defaultColor--text font-weight-regular mb-3"
                        >{{ $t("labels.phone") }}</v-list-item-title
                      >
                      <v-list-item-subtitle
                        style="font-size: 16px"
                        class="defaultColor--text font-weight-bold"
                      >
                        {{ userData.Phone }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>

                <v-layout justify-center align-center mb-10 column>
                  <span class="my-8 defaultColor--text" style="font-size: 12px">
                    {{
                      moment(userData.CreatedAt)
                        .locale("tr")
                        .format("DD MMMM YYYY") + " tarihinde katıldı."
                    }}
                  </span>
                </v-layout>
              </div>
            </v-tab-item>
            <v-tab-item>
              <loading-progress :status="loadingList.myPosts" />
              <div
                v-for="(item, index) in myPostData"
                :key="index"
                class="mt-6"
              >
                <feed-item-card
                  class="test-diagno mb-5"
                  :itemData="item"
                  :index="index"
                />
              </div>
              <div
                class="text-center"
                v-if="myPostData.length > 0 && !moreButtonHiddenMyPost"
              >
                <v-btn
                  text
                  color="primary"
                  @click="loadMoreMyPost()"
                  class="text-capitalize mt-2"
                  :loading="moreButtonLoadingMyPost"
                  :disabled="moreButtonLoadingMyPost"
                >
                  {{ $t("buttons.more") }}
                </v-btn>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import UserService from "../../services/UserService";
import ContentService from "../../services/ContentService";
import UserListItem from "../../components/Users/UserListItem.vue";
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import StoryBanner from "../../components/Stories/StoryBanner.vue";
export default {
  data: function () {
    {
      return {
        tab: 0,

        tabItems: [
          { title: this.$t("tabs.otherAbout"), data: "about" },
          { title: this.$t("tabs.otherPost"), data: "myPosts" },
        ],

        loadingList: {
          about: true,
          myPosts: true,
        },

        userId: null,
        userData: null,

        myPostData: [],
        myPostPage: 1,
        myPostPageSize: 10,
        moreButtonHiddenMyPost: false,
        moreButtonLoadingMyPost: false,
      };
    }
  },
  components: {
    LoadingProgress,
    UserListItem,
    FeedItemCard,
    StoryBanner
  },
  methods: {
    getUserAbout() {
      this.loadingList.about = true;
      UserService.getUserInfo(this.userId)
        .then((res) => {
          console.log("user about :", res.data);
          let area = res.data.Groups.filter((x) => x.Type === "Region");
          this.userData = res.data;
          this.userData.Area = area.length > 0 ? area[0].Name : "";
          if (this.myProfile) this.$store.state.user.Avatar = res.data.Avatar;
          let obj = {
            birthdate: this.moment(res.data.DateOfBirth)
              .locale("tr")
              .format("DD MMMM YYYY"),
            about: res.data.About,
            phone: res.data.Phone,
          };
          this.userUpdateData = obj;
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList.about = false;
        });
    },

    changeTab() {
      setTimeout(() => {
        console.log("change tab");
      }, 500);
    },

    getProfilePost(id) {
      this.loadingList.myPosts = true;
      this.moreButtonLoadingMyPost = true;
      ContentService.getProfilePost(id, this.myPostPage, this.myPostPageSize)
        .then((res) => {
          console.log("profile post :", res.data);
          let data = res.data.Data;
          if (this.myPostPage !== 1) {
            this.myPostData = [...this.myPostData, ...data];
          } else {
            this.myPostData = data;
          }
          if (data.length <= 0) {
            this.moreButtonHidden = true;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.loadingList.myPosts = false;
          this.moreButtonLoadingMyPost = false;
        });
    },

    loadMoreMyPost() {
      this.myPostPage++;
      this.getProfilePost(this.userId);
    },

    sendMessage() {
      console.log("send Message : ", this.userId);
    },

    setup() {
      console.log("params :", this.$route.params.id);
      if (this.$route.params.id) {
        this.userId = this.$route.params.id;
      } else {
        //TODO: Hata mesajı olacak
      }
      this.getUserAbout();
      this.getProfilePost(this.userId);
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.setup();
  },
  watch: {},
};
</script>

<style></style>
